import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import Container from "@material-ui/core/Container";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import "react-quill/dist/quill.snow.css";
//Header
import GenericButton from "components/Buttons/GenericButton";
import LocationHeader from "components/Headers/LocationHeader.js";
import PageTitleHeader from "components/Headers/PageTitleHeader.js";
import { opportunityMap } from "mappers/OpportunityMap";
import { createOpportunityAction } from "redux/actions/opportunitiesAction";
import { labels, titles } from "resources/resources";
import { DATASET } from "utils/const";
import OpportunityCreation from "./Sections/OpportunityCreation";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useStylesLocal = makeStyles((theme) => ({
  buttonsContainerNoExtraPadding: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  fullWidthMobileButton: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  gridItemNoHorizontalPadding: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

function Create(props) {
  const classes = useStylesGeneric();
  const localClasses = useStylesLocal();
  const history = useHistory();
  const intl = useIntl();
  const [opportunityQuestionsState, setOpportunityQuestionsState] = useState(
    []
  );

  const methods = useForm({
    mode: "onChange",
  });

  useEffect(() => { }, []);
  const cancelOnClick = () => {
    history.goBack();
  };

  const focusOnFirstError = (errors) => {
    let fieldName = null;
    const firstErrorField = Object.keys(errors)[0];
    
    if (firstErrorField) {
      if (errors[firstErrorField] && typeof errors[firstErrorField] === 'object' && !errors[firstErrorField].message) {
        const nestedField = Object.keys(errors[firstErrorField])[0];
        if (nestedField) {
          fieldName = `${firstErrorField}.${nestedField}`;
        }
      } else {
        fieldName = firstErrorField;
      }

      if (fieldName) {
        setTimeout(() => {
          methods.setFocus(fieldName);

          setTimeout(() => {
            let element = document.querySelector(`[name="${fieldName}"]`);
            
            if (!element) {
              element = document.querySelector(`input[name="${fieldName}"], select[name="${fieldName}"]`);
            }

            if (!element) {
              const autocompleteId = `form-dropdown-${fieldName}`;
              const autocompleteElement = document.querySelector(`[data-testid="${autocompleteId}"]`);
              if (autocompleteElement) {
                element = autocompleteElement.querySelector('input');
              }
            }

            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
              element.focus();
            }
          }, 100);
        }, 0);
      }
    }
  };

  const onError = (errors) => {
    focusOnFirstError(errors);
  };

  const onSubmit = (data) => {
    props.createOpportunityAction(
      opportunityMap(data, opportunityQuestionsState, props.datasetsState[DATASET.OPPORTUNITY_DOCUMENT_TYPE])
    );
  };
  
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
        <Container maxWidth={false} classes={{ root: classes.containerRoot }}>
          <LocationHeader
            section={"Criar Oferta"}
            subsection={"Emprego e Estágio Profissional"}
            subsectionLink={"/admin/opportunities"}
          />

          <PageTitleHeader
            title={intl.formatMessage(titles.Title_Opportunity_Creation)}
          />

          <OpportunityCreation
            setOpportunityQuestionsState={setOpportunityQuestionsState}
            opportunityQuestionsState={opportunityQuestionsState}
          />

          <Grid
            container
            classes={{
              root:
                classes.containerButtons +
                " " +
                localClasses.buttonsContainerNoExtraPadding,
            }}
          >
            <Grid item xs={12} sm={1} md={6}></Grid>
                <Grid item xs={12} sm={5} md={3} className={localClasses.gridItemNoHorizontalPadding}>
              <FormGroup>
                <GenericButton
                  typeSubmit={false}
                  color="secondary"
                  className={localClasses.fullWidthMobileButton}
                  onClick={() => cancelOnClick()}
                >
                  {intl.formatMessage(labels.Label_Button_Cancel)}
                </GenericButton>
              </FormGroup>
            </Grid>
                <Grid item xs={12} sm={6} md={3} className={localClasses.gridItemNoHorizontalPadding}>
              <FormGroup>
                <GenericButton
                  typeSubmit={true}
                  color="primary"
                  className={localClasses.fullWidthMobileButton}
                  disabled={props.opportunitiesState?.opportunitySubmitLoading}
                  loading={props.opportunitiesState?.opportunitySubmitLoading}
                >
                  {intl.formatMessage(labels.Label_Button_Submit)}
                </GenericButton>
              </FormGroup>
            </Grid>
          </Grid>
        </Container>
      </form>
    </FormProvider>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  createOpportunityAction: (data) => dispatch(createOpportunityAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Create);
